import Input from '../../../components/Input';
import List from '../../../components/List';
import { Fragment } from 'react';
import { generateUtm } from '../helpers';
import { useSelector } from 'react-redux';
import { selectUserInfo } from '../../../../../../store/selectors';
import { selectProduct } from '../../../../../../store/selectors/products';

const PermissionsProductionForm = ({ permissions }) => {
  const { data } = useSelector(selectProduct);
  const {
    data: { recommendationCode, isPartner },
  } = useSelector(selectUserInfo);
  const { formUrl, apiUrl, keySecret, passSecret } = permissions;
  const utm = generateUtm(isPartner, recommendationCode, data.name);

  return (
    <Fragment>
      <List direction='column'>
        {formUrl && <Input label='Integration production form address label' value={formUrl + utm} hasCopy />}

        <Input label='Integration key' value={keySecret} hasCopy />

        <Input label='Integration secret' value={passSecret} hasCopy />

        <Input label='Integration form API' value={apiUrl} hasCopy />
      </List>
    </Fragment>
  );
};

export default PermissionsProductionForm;
